import styled from 'styled-components';

export const TextComponent = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: ${({ theme }) => theme.secundary};
`;
